import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  container: {
    ...dFlex('space-between'),
    padding: '16px',
    width: '100%',
    background: theme.palette.custom.background.dark,
    height: '92px',
  },
  closeIcon: {
    ...dFlex(),
    height: 44,
    padding: 6,
    width: 44,
  },
  link: {
    ...dFlex('initial', 'center'),
  },
  logo: {
    height: 40,
    width: 'auto',
  },
  buttons: {
    ...dFlex(),
    gap: 8,
  },
  chainButton: {
    padding: 6,
    width: 44,
  },
  connectWallet: {
    padding: 6,
    width: 44,
  },
  mobileLogo: {
    height: '60px',
    width: '60px',
  },
}));

export default useStyles;
